// 文章2数据信息
export default {
  id: 'dayunshan_102',
  content: `# 气候、海拔与土壤三重考验下，大云山荞麦如何 “通关”
  ![气候、海拔与土壤三重考验下，大云山荞麦如何 “通关”1](https://cdn.keihong.tech/img/20250518211834098.jpg)

![气候、海拔与土壤三重考验下，大云山荞麦如何 “通关”2](https://cdn.keihong.tech/img/20250518211843375.jpg)

![气候、海拔与土壤三重考验下，大云山荞麦如何 “通关”3](https://cdn.keihong.tech/img/20250518211847027.jpg)

![气候、海拔与土壤三重考验下，大云山荞麦如何 “通关”4](https://cdn.keihong.tech/img/20250518211850556.jpg)

![气候、海拔与土壤三重考验下，大云山荞麦如何 “通关”5](https://cdn.keihong.tech/img/20250518211853577.jpg)

![气候、海拔与土壤三重考验下，大云山荞麦如何 “通关”6](https://cdn.keihong.tech/img/20250518211856693.jpg)

![气候、海拔与土壤三重考验下，大云山荞麦如何 “通关”7](https://cdn.keihong.tech/img/20250518211859778.jpg)`
}
